import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { Attract } from "./Attract";
import { MoveAngle } from "./MoveAngle";
import { MoveGravity } from "./MoveGravity";
import { OutModes } from "./OutModes";
import { Path } from "./Path/Path";
import { Spin } from "./Spin";
import { Trail } from "./Trail";
import { deepExtend } from "../../../../Utils/Utils";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var Move = /*#__PURE__*/function () {
  function Move() {
    _classCallCheck(this, Move);
    this.angle = new MoveAngle();
    this.attract = new Attract();
    this.decay = 0;
    this.distance = {};
    this.direction = "none";
    this.drift = 0;
    this.enable = false;
    this.gravity = new MoveGravity();
    this.path = new Path();
    this.outModes = new OutModes();
    this.random = false;
    this.size = false;
    this.speed = 2;
    this.spin = new Spin();
    this.straight = false;
    this.trail = new Trail();
    this.vibrate = false;
    this.warp = false;
  }
  _createClass(Move, [{
    key: "collisions",
    get: function get() {
      return false;
    },
    set: function set(value) {}
  }, {
    key: "bounce",
    get: function get() {
      return this.collisions;
    },
    set: function set(value) {
      this.collisions = value;
    }
  }, {
    key: "out_mode",
    get: function get() {
      return this.outMode;
    },
    set: function set(value) {
      this.outMode = value;
    }
  }, {
    key: "outMode",
    get: function get() {
      return this.outModes.default;
    },
    set: function set(value) {
      this.outModes.default = value;
    }
  }, {
    key: "noise",
    get: function get() {
      return this.path;
    },
    set: function set(value) {
      this.path = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a, _b, _c;
      if (data === undefined) {
        return;
      }
      if (data.angle !== undefined) {
        if (typeof data.angle === "number") {
          this.angle.value = data.angle;
        } else {
          this.angle.load(data.angle);
        }
      }
      this.attract.load(data.attract);
      if (data.decay !== undefined) {
        this.decay = data.decay;
      }
      if (data.direction !== undefined) {
        this.direction = data.direction;
      }
      if (data.distance !== undefined) {
        this.distance = typeof data.distance === "number" ? {
          horizontal: data.distance,
          vertical: data.distance
        } : deepExtend({}, data.distance);
      }
      if (data.drift !== undefined) {
        this.drift = setRangeValue(data.drift);
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.gravity.load(data.gravity);
      var outMode = (_a = data.outMode) !== null && _a !== void 0 ? _a : data.out_mode;
      if (data.outModes !== undefined || outMode !== undefined) {
        if (typeof data.outModes === "string" || data.outModes === undefined && outMode !== undefined) {
          this.outModes.load({
            default: (_b = data.outModes) !== null && _b !== void 0 ? _b : outMode
          });
        } else {
          this.outModes.load(data.outModes);
        }
      }
      this.path.load((_c = data.path) !== null && _c !== void 0 ? _c : data.noise);
      if (data.random !== undefined) {
        this.random = data.random;
      }
      if (data.size !== undefined) {
        this.size = data.size;
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
      this.spin.load(data.spin);
      if (data.straight !== undefined) {
        this.straight = data.straight;
      }
      this.trail.load(data.trail);
      if (data.vibrate !== undefined) {
        this.vibrate = data.vibrate;
      }
      if (data.warp !== undefined) {
        this.warp = data.warp;
      }
    }
  }]);
  return Move;
}();